import { render, staticRenderFns } from "./DeviceMainTab.html?vue&type=template&id=4eb8dfae&scoped=true&"
import script from "./DeviceMainTab.ts?vue&type=script&lang=ts&"
export * from "./DeviceMainTab.ts?vue&type=script&lang=ts&"
import style0 from "./DeviceMainTab.scss?vue&type=style&index=0&id=4eb8dfae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb8dfae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VRow})
